import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import PublicLayout from "@/components/public/PublicLayout";
import { DEFAULT_HOME, mergeHome } from "@/lib/homeContent";
import {
  HeroSection, TrustSection, ConcernsSection, ClosingSection,
} from "@/components/public/HomeSections";

const ORDER = [
  ["hero", HeroSection], ["concerns", ConcernsSection], ["trust", TrustSection], ["closing", ClosingSection],
];

export default function Home() {
  const [params] = useSearchParams();
  const preview = params.get("preview") === "1";
  const [content, setContent] = useState(DEFAULT_HOME);

  useEffect(() => {
    (async () => {
      try {
        const url = preview ? "/site-content/admin/homepage?mode=draft" : "/site-content/homepage";
        const { data } = await api.get(url);
        setContent(mergeHome(data.content));
      } catch { setContent(DEFAULT_HOME); }
    })();
  }, [preview]);

  return (
    <PublicLayout>
      {ORDER.map(([key, Section]) => (content[key] && content[key].visible !== false
        ? <Section key={key} s={content[key]} /> : null))}
    </PublicLayout>
  );
}
